export function getConsumerApplicationUID(vaspDID: string): string {
  const regex = /^did:[a-zA-Z0-9]*:/;
  const PREFIX = vaspDID.match(regex);
  if (!PREFIX || !vaspDID.includes(PREFIX[0])) {
    return vaspDID;
  }
  return vaspDID.replace(PREFIX[0], "");
}
